export enum DISPATCH_PERMISSIONS {
  DISPATCH_VIEW = 'ORDER_DISPATCHVIEW',
  DISPATCH_WRITE = 'ORDER_DISPATCHWRITE',
}
